import { Link, NavLink } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import { useAuth } from "../pages/login/AuthProvider";
import "../styles/navbar.scss";

export default function MNavbar() {
    const { authorized, chinese_name, account, logout } = useAuth();
    const displayName =
        (!chinese_name || chinese_name === account)
            ? (account?.split("@")[0] ?? "")
            : chinese_name;

    return (
        <Navbar expand="xl" variant="dark" style={{ backgroundColor: '#152046' }}>
  <div className="container d-flex align-items-center">
    {/* 左側 Logo */}
    <NavLink className="navbar-brand logo me-3" to="/">
      <img src="/logo/logo.svg" alt="Logo" />
    </NavLink>

    {/* 中間主選單 Collapse：要能撐開空間 */}
    <Navbar.Collapse id="mnavbarScroll" className="flex-grow-1">
      <Nav className="mx-auto d-flex flex-column flex-xl-row align-items-xl-center">
        <Nav.Item><NavLink className="nav-link" to="./about/origin">關於捷進</NavLink></Nav.Item>
        <Nav.Item><NavLink className="nav-link" to="./becker">美國 Becker</NavLink></Nav.Item>
        <Nav.Item><NavLink className="nav-link" to="./cpa">國際證照考試</NavLink></Nav.Item>
        <Nav.Item><NavLink className="nav-link" to="./service">服務項目</NavLink></Nav.Item>
        <Nav.Item><Link className="nav-link" to="./share">成功案例</Link></Nav.Item>
        <Nav.Item><Link className="nav-link" to="./video">影音專區</Link></Nav.Item>
        <Nav.Item><Link className="nav-link" to="./faq">FAQ</Link></Nav.Item>
      </Nav>
    </Navbar.Collapse>

    {/* 右側區塊：Toggle + 功能 */}
    <div className="d-flex align-items-center m-3">
      <Navbar.Toggle aria-controls="mnavbarScroll" className="d-xl-none me-3" />

      <Link to="/consult" className="me-3 text-white">
        <i className="fa-solid fa-comment"></i>
      </Link>
      <Link to="/audition" className="me-3 text-white">
        <i className="fa-solid fa-headphones"></i>
      </Link>
      {authorized ? (
        <div className="d-flex align-items-center text-white">
          <NavLink to="/member" className="text-white me-3">
            <i className="fa-solid fa-user" />
          </NavLink>
          <div className="memname me-3">{displayName}</div>
          <div
            className="text-white logouttext"
            onClick={() => logout()}
            style={{ cursor: "pointer" }}
          >
            登出
          </div>
        </div>
      ) : (
        <Link to="/member/memberlogin" className="text-white">
          <i className="fa-solid fa-user" />
        </Link>
      )}
    </div>
  </div>
</Navbar>

    );
}
